import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 15px;
`

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 100%;
`

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e5e7eb;
  border-radius: 12px;
  aspect-ratio: 16/9;
  min-height: 200px;
`

const LoadingText = styled.div`
  color: #6b7280;
`

const VideoElement = styled.video`
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  width: 100%;
`
function Video({
  src = 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  maxWidth = '100%',
  maxHeight = '70vh',
}) {
  const videoRef = useRef(null)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const video = videoRef.current
    if (!video) {
      return undefined
    }

    const handleLoadedMetadata = () => {
      const { videoWidth, videoHeight } = video
      setDimensions({ width: videoWidth, height: videoHeight })
      setIsLoading(false)
    }

    video.addEventListener('loadedmetadata', handleLoadedMetadata)

    return () => {
      video.removeEventListener('loadedmetadata', handleLoadedMetadata)
    }
  }, [src])

  const getResponsiveStyles = () => {
    if (dimensions.width === 0 || dimensions.height === 0) {
      return { width: '100%', maxWidth: '800px', aspectRatio: '16/9' }
    }

    return {
      width: '100%',
      maxWidth,
      maxHeight,
      aspectRatio: `${dimensions.width}/${dimensions.height}`,
    }
  }

  return (
    <VideoContainer>
      <VideoWrapper>
        {isLoading && (
          <LoadingContainer>
            <LoadingText>Loading video...</LoadingText>
          </LoadingContainer>
        )}

        <VideoElement
          ref={videoRef}
          src={src}
          autoPlay
          loop
          muted
          playsInline
          controls={false}
          disablePictureInPicture
          style={{
            ...getResponsiveStyles(),
            display: isLoading ? 'none' : 'block',
          }}
          onError={() => {
            setIsLoading(false)
          }}
        >
          Your browser does not support the video tag.
        </VideoElement>
      </VideoWrapper>
    </VideoContainer>
  )
}

Video.propTypes = {
  src: PropTypes.string,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
}

export default Video
